module.exports = __webpack_public_path__ + "img/MIRROR.83706d87.png";